<template>
    <SelectAsync :multiple="multiple" v-model="model" :searchFunction="search" :placeholder="placeholder" :hasError="hasError">
        <template slot="option" slot-scope="props">
            <div>{{ props.option.name[$config.config.displayLanguage] }}</div>
        </template>
        <template slot="singleLabel" slot-scope="props">
            {{ props.option.name[$config.config.displayLanguage] }}
        </template>
        <template slot="tag" slot-scope="props">
            <span class="multiselect__tag" style="padding-right: 14px !important;"><span>{{ props.option.name[$config.config.displayLanguage] }}</span></span>
        </template>
    </SelectAsync>
</template>

<script>
    import ModelsSelects from '../../../mixins/ModelsSelects'

    export default {
        props: {
            multiple: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: 'Select a type'
            }
        },
        methods: {
            defaultSearch(search) {
                return new Promise((resolve, reject) => {
                    return this.$api.types.get({
                        search: search,
                        depth: 1
                    }).then(response => {
                        let categories = this.$options.filters.pluck(response.data, 'children').flat()
                        resolve({
                            data: categories
                        })
                    }).catch(error => {
                        reject(error)
                    })
                })
            }
        },
        mixins: [
            ModelsSelects
        ]
    }
</script>
